import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    signal,
} from '@angular/core';
import { IconComponent } from '@interacta-shared/ui-icons';
import { uuid } from '@interacta-shared/util';
import { getThinkingLabel } from '@modules/ai-convo/helpers/ai-convo-thinking.utils';
import { AIConvoThinkingStep } from '@modules/ai-convo/models/ai-convo-thinking.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-ai-convo-thinking-steps',
    templateUrl: './ai-convo-thinking-steps.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, TranslatePipe],
})
export class AIConvoThinkingStepsComponent {
    readonly steps = input<AIConvoThinkingStep[] | undefined>();

    readonly panelId = `ai-convo-thinking-steps-${uuid()}`;
    readonly expanded = signal(false);

    readonly items = computed(() =>
        (this.steps() ?? []).flatMap((step) => {
            const label = getThinkingLabel(step, 'past');
            return label ? [{ id: step.id, label }] : [];
        }),
    );

    toggle(): void {
        this.expanded.update((value) => !value);
    }
}
